import React, { useState, useEffect } from 'react';
import Slidebar from './Slidebar';
import apiInstance from '../../utils/axios';
import Swal from 'sweetalert2';
import UserData from '../plugin/UserData';

function CustomerSettings() {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [country, setCountry] = useState('');
  const [image, setImage] = useState(null);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // Track the initial values of email and phone to prevent errors on update
  const [initialEmail, setInitialEmail] = useState('');
  const [initialPhone, setInitialPhone] = useState('');

  const fetchProfileData = () => {
    const ud = UserData();
    if (!ud || !ud.user_id) {
      Swal.fire('Error', 'Debes iniciar sesión para ver la configuración.', 'error');
      return;
    }
    apiInstance.get(`user/profile/${ud.user_id}/`)
      .then((res) => {
        const { full_name, address, city, state, country, user, image } = res.data;
        setFullName(full_name || '');
        setEmail(user?.email || '');
        setPhone(user?.phone || '');
        setAddress(address || '');
        setCity(city || '');
        setState(state || '');
        setCountry(country || '');
        setImage(image || null);

        // Store initial values of email and phone
        setInitialEmail(user?.email || '');
        setInitialPhone(user?.phone || '');
      })
      .catch(() => {
        Swal.fire('Error', 'Error al cargar los datos del perfil', 'error');
      });
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrors({});

    const userData = {};
    if (email !== initialEmail) userData.email = email;
    if (phone !== initialPhone) userData.phone = phone;

    // Create FormData to handle file upload
    const formData = new FormData();
    formData.append('full_name', fullName);
    formData.append('address', address);
    formData.append('city', city);
    formData.append('state', state);
    formData.append('country', country);
    if (image) {
      formData.append('image', image);  // Add the image file if it exists
    }

    // If the email or phone has changed, include them in the FormData
    if (email !== initialEmail) formData.append('email', email);
    if (phone !== initialPhone) formData.append('phone', phone);

    try {
      const ud = UserData();
      if (!ud || !ud.user_id) {
        throw new Error('No autenticado');
      }
      const { data } = await apiInstance.patch(
        `user/profile/${ud.user_id}/`,
        formData, // Send FormData for file upload
        {
          headers: {
            'Content-Type': 'multipart/form-data', // This is important for file uploads
          },
        }
      );

              Swal.fire('Éxito', 'Perfil actualizado exitosamente', 'success').then(() => {
        window.location.reload(); // Refresh the page after successful update
      });
    } catch (error) {
      const res = error.response?.data || {};
      setErrors(res.user || {});
      Swal.fire('Error', res.message || error.message || 'Error en la actualización', 'error');
    }

    setIsLoading(false);
  };

  return (
    <div>
      <main className="mt-5">
        <div className="container">
          <section className="">
            <div className="row">
              <Slidebar />

              <div className="col-lg-9 mt-1">
                <section className="">
                  <main className="mb-5">
                    <div className="container px-4">
                      <section className="">
                        <h3 className="mb-3">
                          <i className="fas fa-gear fa-spin" /> Configuración
                        </h3>
                        <form onSubmit={handleSubmit} encType="multipart/form-data">
                          <div className="row">
                            <div className="col-lg-12 mb-3">
                              <label className="form-label">Imagen de Perfil</label>
                              <input
                                type="file"
                                className="form-control"
                                onChange={(e) => setImage(e.target.files[0])}
                              />
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-lg-12">
                              <label className="form-label">Nombre Completo</label>
                              <input
                                type="text"
                                className="form-control"
                                value={fullName}
                                onChange={(e) => setFullName(e.target.value)}
                              />
                            </div>
                            
                            <div className="col-lg-6 mt-3">
                              <label className="form-label">Dirección de Email</label>
                              <input
                                type="email"
                                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                              />
                              {errors.email && 
                                <div className="invalid-feedback">{errors.email}</div>
                              }
                            </div>
                            
                            <div className="col-lg-6 mt-3">
                              <label className="form-label">Celular</label>
                              <input
                                type="text"
                                className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                              />
                              {errors.phone && 
                                <div className="invalid-feedback">{errors.phone}</div>
                              }
                            </div>
                          </div>

                          <br />
                          <div className="row">
                            <div className="col-lg-6 mt-3">
                              <label className="form-label">Dirección</label>
                              <input
                                type="text"
                                className="form-control"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                              />
                            </div>
                            <div className="col-lg-6 mt-3">
                              <label className="form-label">Ciudad</label>
                              <input
                                type="text"
                                className="form-control"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                              />
                            </div>
                            <div className="col-lg-6 mt-3">
                              <label className="form-label">Estado</label>
                              <input
                                type="text"
                                className="form-control"
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                              />
                            </div>
                            <div className="col-lg-6 mt-3">
                              <label className="form-label">País</label>
                              <input
                                type="text"
                                className="form-control"
                                value={country}
                                onChange={(e) => setCountry(e.target.value)}
                              />
                            </div>
                          </div>

                          {isLoading ? (
                            <button className="btn btn-primary mt-5" type="submit">
                              <span className="mr-2">Actualizando</span>
                              <i className="fas fa-spinner fa-spin" />
                            </button>
                          ) : (
                            <button type="submit" className="btn btn-primary mt-5">
                              Guardar Cambios
                            </button>
                          )}
                        </form>
                      </section>
                    </div>
                  </main>
                </section>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}

export default CustomerSettings;